import React from 'react';
import { number, string, bool } from 'prop-types';
import QuotesCompactList from './QuotesCompactList';
import QuotesCarousel from './QuotesCarousel';
import { useQuoteContext } from '../../hooks/useQuoteContext';

const QuotesNoTabsView = ({ maxListSize, componentId, isMobile }) => {
  const { quotes } = useQuoteContext();

  return (
    <>
      {isMobile ? (
        <div className="sui-h-full">
          <QuotesCompactList quotes={quotes} maxListSize={maxListSize} componentId={componentId} />
        </div>
      ) : (
        <div>
          <QuotesCarousel quotes={quotes} componentId={componentId} />
        </div>
      )}
    </>
  );
};

QuotesNoTabsView.propTypes = {
  maxListSize: number,
  componentId: string,
  isMobile: bool
};
QuotesNoTabsView.defaultProps = {
  maxListSize: 3,
  componentId: '',
  isMobile: false
};

export default QuotesNoTabsView;
